import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    continueCta: 'Confirm my address',
    labels: {
      city: 'Zip code - City',
      country: 'Country',
      street: 'Street',
      streetAddition: 'Address second line',
    },
    section: 'Home Address',
    title: 'Verify your personal address',
  },
  fr: {
    continueCta: 'Confirmer mon adresse',
    labels: {
      city: 'Code postal - Ville',
      country: 'Pays',
      street: 'Voie',
      streetAddition: 'Complément d’adresse',
    },
    section: 'Adresse personnelle',
    title: 'Vérifiez votre adresse personelle',
  },
} as const);
